import { union } from 'io-ts/lib/Decoder';

import { AlignmentUpdated } from './AlignmentUpdated';
import { ChangeDimensionLine } from './ChangeDimensionLine';
import { ChangeOverallDimensionLine } from './ChangeOverallDimensionLine';
import { ExternalDimensionsConfirmed } from './ExternalDimensionsConfirmed';
import { ExternalFrameDimensionsConfirmed } from './ExternalFrameDimensionsConfirmed';
import { FloorLevelAssigned } from './FloorLevelAssigned';
import { FrameCreated } from './FrameCreated';
import { FrameDeleted } from './FrameDeleted';
import { FramesSnapshot } from './FramesSnapshot';
import { FrameUpdated } from './FrameUpdated';
import { JobSetupUpdated } from './JobSetupUpdated';
import { LengthCorrectionConfirmed } from './LengthCorrectionConfirmed';
import { MeasurementUpdated } from './MeasurementUpdated';
import { OpeningCreated } from './OpeningCreated';
import { OpeningDeleted } from './OpeningDeleted';
import { OpeningUpdated } from './OpeningUpdated';
import { ScaleUpdated } from './ScaleUpdated';
import { SegmentCreated } from './SegmentCreated';
import { SegmentDeleted } from './SegmentDeleted';
import { SegmentUpdated } from './SegmentUpdated';

/**
 * Union of all HITL change message types.
 */
export const Type = union(
	AlignmentUpdated,
	ChangeDimensionLine,
	ChangeOverallDimensionLine,
	ExternalDimensionsConfirmed,
	ExternalFrameDimensionsConfirmed,
	FloorLevelAssigned,
	FrameCreated,
	FrameDeleted,
	FramesSnapshot,
	FrameUpdated,
	JobSetupUpdated,
	LengthCorrectionConfirmed,
	MeasurementUpdated,
	OpeningCreated,
	OpeningDeleted,
	OpeningUpdated,
	ScaleUpdated,
	SegmentCreated,
	SegmentDeleted,
	SegmentUpdated
);
